import { module } from 'modujs';
import LocomotiveScroll from 'locomotive-scroll';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.scroll = new LocomotiveScroll({
            el: this.el,
            smooth: false,
            reloadOnContextChange: true,
            tablet: {
              smooth: false,
              multiplier: 10,
            },
            smartphone: {
              smooth: false,
              multiplier: 10,
            }
        });

        if($(document).outerWidth() < 501) {
          $('.b-relation-pages_wrap .c-card').attr('data-scroll-speed', 0);
        }

        setTimeout(() => {
          this.scroll.update();
          /* Detect first section body background class */
          let $sections = $('#main section');
          if($sections.length) {
            let bg = $($sections[0]).attr('data-body');
            document.querySelector('body').setAttribute('data-bg', bg);
          }
        }, 500);
        new ResizeObserver(() => this.scroll.update()).observe(this.el);

        this.scroll.on('call', (func, way, obj, id) => {
            // Using modularJS
            this.call(func[0], { way, obj }, func[1], func[2]);
            
            if (way === 'enter') {
              switch (func) {
                case "pageColor":
                  // get color code from data-scroll-id  assigned to body by obj.id
                  // document.querySelector('body').style.backgroundColor = obj.el.getAttribute('data-color');
                  document.querySelector('body').setAttribute('data-bg', obj.el.getAttribute('data-body'));
                  break;
                  
                case "anchor":
                  document.querySelector("[data-anchor='"+obj.el.getAttribute('id')+"']").classList.add('is-active');
                  break;
             }
            } else{
              switch (func) {
                case "anchor":
                  document.querySelector("[data-anchor='" + obj.el.getAttribute('id') + "']").classList.remove('is-active');
                  break;
              }
            }

            if(func == 'animateNumber') {
              $(obj).prop('Counter',0).animate({
                Counter: $(obj.el).text(),
              }, {
                duration: 4000,
                easing: 'swing',
                step: function (now) {
                  $(obj.el).text(Math.ceil(now).toLocaleString('cs-CZ'));
                },
              });
            }
        });

      this.scroll.on('scroll', (args) => {
        if (args.scroll.y >= 20) {
          document.getElementById('main-header').classList.add('-scrolling');
        } else {
          document.getElementById('main-header').classList.remove('-scrolling');
        }

        // for (let i = 0; i < document.getElementsByClassName('b-accueil-intro_deco').length; i++){
        //   document.getElementsByClassName('b-accueil-intro_deco')[i].classList.add('-scrolling')
        // }
      })
    }

    toggleLazy(args) {
        let src = this.getData('lazy', args.obj.el)
        if (src.length) {
            if (args.obj.el.tagName === 'IMG') {
                args.obj.el.src = src
            } else {
                args.obj.el.style.backgroundImage = `url('${src}')`
            }
            this.setData('lazy', '', args.obj.el)
        }
    }

    destroy() {
        this.scroll.destroy();
    }

    scrollTo(target) {
      this.scroll.scrollTo(target, {'offset': -150});
    }

    update() {
      this.scroll.update();
    }

}
